import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FadeIn } from './ui/FadeIn';
export function FAQSection() {
  const faqs = [{
    q: '¿Necesito una sobadora o equipo profesional?',
    a: 'No. El método está diseñado 100% para hacerse con rodillo y utensilios que ya tenés en tu cocina. Sin inversión en equipos.'
  }, {
    q: '¿Sirve aunque nunca haya hecho pastelería?',
    a: 'Sí. Stella pensó el método para personas sin experiencia previa. Cada paso está explicado con el nivel de detalle que necesitás.'
  }, {
    q: '¿Puedo usarlo para empezar a vender?',
    a: 'Absolutamente. El Bono 2 está específicamente diseñado para eso: precios, empaques y cómo conseguir tus primeros clientes.'
  }, {
    q: '¿Cómo recibo el material?',
    a: 'Al momento de pagar recibís acceso inmediato al PDF descargable. Es tuyo para siempre.'
  }, {
    q: '¿Y si el método no me funciona a mí?',
    a: 'Tenés 7 días de garantía total. Si no estás satisfecha, te devolvemos el dinero. Punto.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const toggleFaq = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="bg-white py-12 md:py-16" data-id="element-59">
      <div className="max-w-3xl mx-auto px-4" data-id="element-60">
        <FadeIn data-id="element-61">
          <h2 className="text-3xl md:text-5xl font-bold text-brand-brown text-center mb-12" data-id="element-62">
            Preguntas frecuentes
          </h2>
        </FadeIn>

        <div className="space-y-4" data-id="element-63">
          {faqs.map((faq, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-64">
              <div className="border border-brand-gold/20 rounded-xl overflow-hidden bg-brand-cream-light" data-id="element-65">
                <button onClick={() => toggleFaq(index)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" data-id="element-66">
                  <span className="font-bold text-brand-brown text-lg pr-8" data-id="element-67">
                    {faq.q}
                  </span>
                  <span className="text-brand-orange text-2xl flex-shrink-0" data-id="element-68">
                    {openIndex === index ? '−' : '+'}
                  </span>
                </button>

                <AnimatePresence data-id="element-69">
                  {openIndex === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} data-id="element-70">
                      <div className="px-6 pb-5 text-brand-brown/80 leading-relaxed" data-id="element-71">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}